import { connect } from 'react-redux'
import Examples from './examples'
import {
  fetchExamples,
  filterToSchoolOrganisation,
  filterToAll
} from '../../../../stores/examples/examples.actions'
import {
  getFetchExamplesRequest,
  getExamples,
  getSchoolOrganisationFilter
} from '../../../../stores/examples/examples.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me }) => {
  const fetchExamplesRequest = getFetchExamplesRequest(state)
  const examples = getExamples(state)
  const schoolOrganisationFilter = getSchoolOrganisationFilter(state)
  const user = me.account
  return {
    noExamples: examples && !examples.result.length,
    pending: !examples || fetchExamplesRequest.pending,
    schoolOrganisationFilter,
    schoolIsPartOfOrganisation:
      user.teacher_type &&
      user.teacher_type.school &&
      user.teacher_type.school.school_organisations &&
      user.teacher_type.school.school_organisations.filter(
        org => org.local_authority
      ).length > 0
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => {
    return dispatch(fetchExamples())
  },
  onSelect: (e, schoolOrganisationFilter) => {
    e === 'schoolOrganisation' && dispatch(filterToSchoolOrganisation())
    e === 'all' && dispatch(filterToAll())
    return dispatch(fetchExamples(e === 'schoolOrganisation'))
  }
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Examples)
)
